import React, { useEffect, useState } from 'react';
import { ArrowRightIcon, ShoppingCartIcon } from 'lucide-react';
import { handleCheckout } from '../utils/checkout';
import { pricing } from '../data/content';
import { useLaunchCountdown } from '../hooks/useLaunchCountdown';
export function StickyCTA() {
  const [pastHero, setPastHero] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const {
    isActive,
    formatted
  } = useLaunchCountdown();
  useEffect(() => {
    const hero = document.getElementById('hero');
    const heroObserver = new IntersectionObserver(([entry]) => {
      setPastHero(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    if (hero) heroObserver.observe(hero);
    const visibleBlockers = new Set<Element>();
    const blockerObserver = new IntersectionObserver(entries => {
      entries.forEach(e => e.isIntersecting ? visibleBlockers.add(e.target) : visibleBlockers.delete(e.target));
      setBlocked(visibleBlockers.size > 0);
    }, {
      threshold: 0.2
    });
    document.querySelectorAll('[data-hide-sticky]').forEach(el => blockerObserver.observe(el));
    return () => {
      heroObserver.disconnect();
      blockerObserver.disconnect();
    };
  }, []);
  const show = pastHero && !blocked;
  return <div aria-hidden={!show} className={`fixed inset-x-0 bottom-0 z-40 bg-cocoa border-t border-ivory/10 px-3 pt-2 pb-[max(env(safe-area-inset-bottom),10px)] transition-[transform,opacity] duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] ${show ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0 pointer-events-none'}`} data-id="element-215" data-mp="3kb4bkw2ri94b">
      <div className="max-w-3xl mx-auto" data-id="element-216" data-mp="bu9ha5015x1u">
        <div className="flex items-center gap-2 md:gap-3 px-1 pb-2 font-sans text-[10px] md:text-[11px] font-semibold tracking-wider" data-id="element-217" data-mp="6vg64j87ui4u">
          <span className="h-1.5 w-1.5 md:h-2 md:w-2 rounded-full bg-terracotta flex-shrink-0" aria-hidden="true" data-id="element-218" data-mp="2dn79pzpwanm9" />
          <span className="text-ivory/65 truncate min-w-0" data-id="element-219" data-mp="28p5n54t9g661">PRECIO DE LANZAMIENTO POR TIEMPO LIMITADO</span>
          {isActive && <span className="flex-shrink-0 rounded-md bg-ivory/10 px-2 py-0.5 font-mono tabular-nums text-[11px] md:text-xs font-bold text-coral" data-id="element-220" data-mp="hizqm9xn20v9">
              {formatted}
            </span>}
          <span className="ml-auto flex-shrink-0 font-bold text-coral" data-id="element-221" data-mp="qjpkv9793j6v">
            AHORRAS {pricing.savings}
          </span>
        </div>

        <button type="button" onClick={handleCheckout} tabIndex={show ? 0 : -1} className="w-full h-14 md:h-16 rounded-2xl bg-[linear-gradient(100deg,#B5654A_0%,#98492F_45%,#74465A_100%)] text-ivory flex items-center justify-between gap-3 px-4 md:px-5 transition-transform duration-150 ease-out active:scale-[0.99]" data-id="element-222" data-mp="vi96t9luguz8">
          <span className="flex items-center gap-3 min-w-0" data-id="element-223" data-mp="1ea1yn0p6ga5d">
            <ShoppingCartIcon className="w-5 h-5 flex-shrink-0" aria-hidden="true" data-id="element-224" data-mp="1e7fjofzyisd4" />
            <span className="flex flex-col items-start min-w-0" data-id="element-225" data-mp="1j8wepuvrfkls">
              <span className="font-sans text-[10px] md:text-[11px] font-semibold tracking-wider text-ivory/75 truncate max-w-full" data-id="element-226" data-mp="1tdl88id6sb1u">
                BIBLIOTECA PAUSA PROPIA
              </span>
              <span className="font-sans font-bold text-[15px] md:text-lg whitespace-nowrap leading-tight" data-id="element-227" data-mp="1jdm1mr0buurm">
                Quiero mi biblioteca
              </span>
            </span>
          </span>
          <span className="flex items-center gap-2 flex-shrink-0" data-id="element-228" data-mp="2c3b315gy8wtr">
            <s className="hidden sm:inline font-sans text-sm text-ivory/60" data-id="element-229" data-mp="273ydue2lvdo0">{pricing.regular}</s>
            <span className="font-sans font-bold text-lg md:text-2xl" data-id="element-230" data-mp="22d8a159tvivf">{pricing.launch}</span>
            <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5" aria-hidden="true" data-id="element-231" data-mp="22avn0dp7qibi" />
          </span>
        </button>
      </div>
    </div>;
}